import React from 'react';
import './Header.scss'

import { Link } from 'react-router-dom';
import { Layout , Menu } from 'antd';
const { Header } = Layout;


class header extends React.Component{
  constructor(props) {
    super(props)
    // console.log(props)
  }

  componentDidMount(){
    const { pathname } = this.props.props.location
    // console.log(pathname.split("/")[1])
    this.setState({
      current: pathname.split("/")[1] == "checkresult" ? "checklicense" : pathname.split("/")[1]
    })
  }
  state = {
    current: 'printlicense',
  };

  handleClick = e => {
    this.setState({
      current: e.key,
    });
  };
  // <Link to="/lightlicense">执照亮照</Link>
  // <a href="https://zzlz.gsxt.gov.cn/businessShow/">执照亮照</a>
  // <a href="http://13.9.6.36:8083/businessShow">执照亮照</a>
  render() {
    return (
      <Header className="header1">
        <div className="headerright">
          <Menu onClick={this.handleClick} selectedKeys={[this.state.current]} mode="horizontal">
            <Menu.Item key="printlicense">
              <Link to="/printlicense">打印执照</Link>
            </Menu.Item>
            <Menu.Item key="printenterprise">
              <Link to="/printenterprise">打印企业身份码</Link>
            </Menu.Item>

            <Menu.Item key="lightlicense">
              <a href="https://zzlz.gsxt.gov.cn/businessShow/">执照亮照</a>
            </Menu.Item>

            <Menu.Item key="checklicense">
              <Link to="/checklicense">验证执照</Link>
            </Menu.Item>

            <Menu.Item key="batch">
              <Link to="/batch">批量授权</Link>
            </Menu.Item>

            <Menu.Item key="userguide">
              <Link to="/userguide">使用指南</Link>
            </Menu.Item>

            <Menu.Item key="problem" className="lastLi">
              <Link to="/problem">常见问题</Link>
            </Menu.Item>
          </Menu>
        </div>

        <div className="logo">
          <img src={require('../assets/img/head_logo.png')} />
        </div>
      </Header>
    )
  }
}

export default header;
